<template>
  <popup
    :env="env"
    :type="type"
    :slug="slug"
    :visible.sync="visible"
    :title="couponInfo.title"
    :subtitle="couponInfo.subtitle"
    :imageUrl="couponInfo.imageUrl"
    :buttonText="couponInfo.buttonText"
    :buttonIcon="'download'"
    @callback="callback"
  />
</template>
<script>
import moment from 'moment';
import { ERRORS } from '../redeem-message';
import Popup from './../popup/app';
import api from './api';
import auth from '../auth';

export default {
  name: 'coupon-popup',
  components: { Popup },
  props: ['env', 'slug'],
  mixins: [auth],
  computed: {
    popupId() {
      const [popupId] = location.hash.split('&').filter((param) => param.indexOf('popup_id') === 0);
      return (popupId && popupId.split('=')[1]) || null;
    },
  },
  methods: {
    getGenerateRandom(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    async loadPopupList(slug) {
      const {
        data: { data },
      } = await api.getPopups(slug);

      if (data.length) {
        const couponInfo = data[this.getGenerateRandom(0, data.length - 1)];
        this.visible = true;
        this.couponInfo = { ...couponInfo };
      }
    },
    isActive(showAt, hideAt) {
      return moment().isBetween(showAt, hideAt);
    },
    async showCouponMessage() {
      let subtitle = '';
      let title = '';

      try {
        const {
          data: {
            data: { couponIds },
          },
        } = await api.requestCouponsByPopupId(this.couponInfo.id);
        title = '쿠폰 발급 완료';
        subtitle = `
            총 <span style="font-weight: bold">${couponIds.length}개</span>의 쿠폰 발급이 완료되었습니다.</br>
            발급된 쿠폰은 <a href="/me/coupon"><span style="font-weight: bold;text-decoration: underline;color: #000000;">마이페이지 > 쿠폰</span></a>  확인하실 수 있습니다.
          `;
      } catch (err) {
        if (err && err.message) {
          title = '쿠폰 발급 실패';

          switch (err.message) {
            case ERRORS.INVALID_ACCESS_TOKEN:
              this.visible = false;
              this.authorize('signIn', {
                message: '쿠폰 발급을 위해, 로그인 해주세요.',
                popupId: this.couponInfo.id,
              });
              break;
            case ERRORS.USER_COUPON_DUPLICATED_ERROR:
            case ERRORS.USER_POPUP_DUPLICATED_ERROR:
              subtitle = `이미 발급받은 쿠폰입니다.`;
              break;
            case ERRORS.COUPON_INVALID:
              subtitle = `
               불편을 드려 죄송합니다.<br/>
               쿠폰 재고가 모두 소진되었습니다.
              `;
              break;
            case ERRORS.POPUP_NOT_FOUND:
              subtitle = `기간이 종료되었습니다.`;
              break;
            case ERRORS.COUPON_REDEEM_FAILED:
            default:
              subtitle = `
               불편을 드려 죄송합니다.<br/>
               알 수 없는 오류로 쿠폰이 지급되지 않았습니다.<br/>
               잠시 후 다시 시도해 주세요.
              `;
          }
        }
      } finally {
        this.type = 'confirm';
        this.couponInfo = {
          title,
          subtitle,
          buttonText: '확인',
        };
      }
    },
    checkPopupCustomers() {
      setTimeout(async () => {
        const { data } = await api.getPopupCustomers(this.popupId);

        if (data.data.popup_customer && data.data.popup_customer.state === 'COMPLETED') {
          this.visible = true;
          this.type = 'confirm';
          this.couponInfo = {
            title: '쿠폰 발급 실패',
            subtitle: '이미 발급받은 쿠폰입니다.',
            buttonText: '확인',
          };
        } else {
          this.showCouponPopup();
        }
      }, 1000);
    },
    callback() {
      this.showCouponMessage();
    },
    async showCouponPopup() {
      await this.loadPopupList(this.slug);
      if (this.couponInfo.state === 'NORMAL' && this.isActive(this.couponInfo.showAt, this.couponInfo.hideAt)) {
        this.visible = true;
      }
    },
  },
  data() {
    return {
      visible: false,
      type: 'alert',
      couponInfo: {
        id: '',
        title: '',
        subtitle: '',
        imageUrl: '',
        buttonText: '',
        state: '',
        showAt: '',
        hideAt: '',
      },
    };
  },
  created() {
    if (this.popupId) {
      this.checkPopupCustomers();
    } else {
      setTimeout(() => {
        this.showCouponPopup();
      }, 0);
    }
  },
};
</script>
